import React from 'react'
import moment from 'moment'
import { StyledDiaryAlert, StyledDiaryAlertTime, StyledDiaryAlertEvent, StyledDiaryAlertAdvice, StyledDiaryAlertWrapper } from './styled';
import Icon from '../Icon';

const DiaryAlert = ({ alert, urgent,manual }) => {
    return (
        <StyledDiaryAlert>
            <StyledDiaryAlertWrapper>
                <StyledDiaryAlertTime>
                    {Number.isInteger(alert.time) ? moment.unix(alert.time).format("DD.MM.YYYY HH:mm") : alert.time}
                </StyledDiaryAlertTime>
                {manual && <Icon name="manual" />}
            </StyledDiaryAlertWrapper>
            <StyledDiaryAlertEvent urgent={urgent}>{alert.event}</StyledDiaryAlertEvent>
            {
                alert.note &&
                alert.note.split('\n').map(note => (
                    <StyledDiaryAlertEvent key={note}>{note}</StyledDiaryAlertEvent>
                ))
            }
            <StyledDiaryAlertAdvice>{alert.advice}</StyledDiaryAlertAdvice>
        </StyledDiaryAlert>
    )
}

export default DiaryAlert
